export default __webpack_public_path__ + "static/media/tete70.498291f3.png";